export const enum VerificationMethod {
  Veriff = 'veriff',
  WebId = 'webid',
}
